// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip_chip__B5MPO","chip__remove-button":"chip_chip__remove-button__CKbut","focus-visible":"chip_focus-visible__dDVhE"};